/**
 * API Endpoints Constants
 * Centralized location for all API endpoint definitions
 */

export enum ApiEndpoints {
  // Ingestion API endpoints
  INGESTION_SURVEYS = "/ingestion/v1/surveys",

  //we are using ingestionInternalSurveyId for surveyId
  INGESTION_SURVEY_QUESTIONS = "/ingestion/v1/surveys/{surveyId}/questions",
  INGESTION_SURVEY_IMPORT = "/ingestion/v1/surveys/{surveyId}/import",
  INGESTION_SURVEY_IMPORT_CADENCE = "/ingestion/v1/surveys/{id}/import-cadence",
  INGESTION_SURVEY_IMPORT_HISTORY = "/ingestion/v1/surveys/{surveyId}/import-history",

  // Aggregation API endpoints
  AGGREGATION_SURVEYS = "/aggregation/v1/surveys",
  AGGREGATION_DATASETS = "/aggregation/v1/datasets",
  AGGREGATION_DATASETS_BY_ID = "/aggregation/v1/datasets/{id}",
  AGGREGATION_DATASETS_SAVE = "/aggregation/v1/dataset/{id}",
  AGGREGATION_DATASETS_QUESTIONS = "/aggregation/v1/datasets/{id}/questions",
  AGGREGATION_DATASETS_RECONCILIATION_DETAILS = "/aggregation/v1/datasets/{id}/reconciliation-details",
  AGGREGATION_DATASETS_QUESTIONS_RESPONSE = "/aggregation/v1/questions/responses/search",
  AGGREGATION_QUESTIONS_RESPONSES_SEARCH = "/aggregation/v1/questions/responses/search",
  AGGREGATION_DATASETS_STATUS = "/aggregation/v1/datasets/{id}/status",
  AGGREGATION_DATASETS_QUESTION_VARIABLES = "/aggregation/v1/datasets/{id}/questions/{question_id}/variables",
  AGGREGATION_DATASETS_QUESTION_VARIABLES_BY_ELEMENT = "/aggregation/v1/datasets/{id}/questions/{dataset_element_id}/variables",
  AGGREGATION_DATASETS_WEIGHT_CONFIGURATIONS = "/aggregation/v1/datasets/{id}/weight-configurations",
  AGGREGATION_DATASETS_TIME_BOUNDS = "/aggregation/v1/datasets/{id}/time-bounds",

  DASHBOARD_DASHBOARDS_LIST = "/dashboard/v1/dashboards",
  DASHBOARD_DASHBOARDS = "/dashboard/v1/dashboards",
  DASHBOARD_DUPLICATE = "/dashboard/v1/dashboards/{dashboardId}/duplicate",
  DASHBOARD_CLIENTS = "/auth/v1/clients",
  DASHBOARD_CLIENTS_BY_ID = "/dashboard/v1/dashboards/{dashboardId}/clients",
  DASHBOARD_BY_ID = "/dashboard/v1/dashboards/{dashboardId}",
  // DASHBOARD_TABS_LAYOUT = "/dashboard/v1/dashboards/tabs/{dashboardId}/layout",
  DASHBOARD_TABS = "/dashboard/v1/dashboards/{dashboardId}/tabs",
  DASHBOARD_TAB_BY_ID = "/dashboard/v1/dashboards/tabs/{tabId}",
  DASHBOARD_TAB_LAYOUT = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/layout",
  DASHBOARD_TAB_DUPLICATE = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/duplicate",
  DASHBOARD_TABS_SWAP_ORDER = "/dashboard/v1/dashboards/tabs/swap-order",
  DASHBOARD_CLIENT_USERS_SEARCH = "/dashboard/v1/dashboards/{dashboardId}/client-users/search",
  USERS_INVITE = "/dashboard/v1/dashboards/{dashboardId}/invite-users",
  SHARE_DASHBOARD_WITH_CLIENTS_USERS = "/dashboard/v1/dashboards/{dashboardId}/share",
  REVOKE_DASHBOARD_ACCESS_FOR_CLIENTS_USERS = "/dashboard/v1/dashboards/{dashboardId}/revoke",
  DASHBOARD_FILTERS = "/dashboard/v1/dashboards/{dashboardId}/filters",
  DASHBOARD_LOCK = "/dashboard/v1/dashboards/{dashboardId}/lock",
  TAB_WIDGETS = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/widgets",
  TAB_WIDGET_BY_ID = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/widgets/{widgetId}",
  TAB_WIDGET_DUPLICATE = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/widgets/{widgetId}/duplicate",
  TAB_WIDGET_REORDER = "/dashboard/v1/dashboards/{dashboardId}/tabs/{tabId}/widgets/{widgetId}/reorder",
  DASHBOARD_WIDGETS_VALIDATE = "/dashboard/v1/dashboards/widgets/validate",
}

/**
 * Helper function to replace path parameters in endpoints
 * @param endpoint - The endpoint with path parameters in {param} format
 * @param params - Object containing parameter values
 * @returns The endpoint with parameters replaced
 */

export const buildEndpoint = (
  endpoint: string,
  params: Record<string, string | number>,
): string => {
  let result = endpoint;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`{${key}}`, String(value));
  });
  return result;
};
